/**
 * ============================================
 * CART GOAL PROGRESS SCRIPT (OPTIMIZED)
 * ============================================
 * IMPORTANT: Add this file to your assets folder
 * Then load it in theme.liquid with defer:
 * <script src="{{ 'cart-goal-progress.js' | asset_url }}" defer></script>
 *
 * OPTIMIZATIONS:
 * - Polling reduced from 500ms to 2000ms (4x fewer network requests)
 * - Removed duplicate DOMContentLoaded listeners
 * - Extracted from inline script to cacheable asset file
 * ============================================
 */

(function() {
  'use strict';

  const STRAPLESS_BRA_HANDLE = 'free-strapless-push-up-bra';
  const LAUNDRY_BAG_HANDLE = 'free-delicate-laundry-bag';
  const POLLING_INTERVAL = 2000; // Changed from 500ms to 2000ms

  let productCollectionCache = {};
  let lastState = null;
  let tier2PreviouslyUnlocked = false;
  let tier3PreviouslyUnlocked = false;
  let straplessBraInCart = false;
  let laundryBagInCart = false;

  // Load product images for the milestone markers
  async function loadProductImages() {
    const productHandles = [
      { handle: STRAPLESS_BRA_HANDLE, imageIndex: 0 },
      { handle: LAUNDRY_BAG_HANDLE, imageIndex: 0 }
    ];

    for (const { handle, imageIndex } of productHandles) {
      try {
        const response = await fetch(`/products/${handle}.json`);
        if (response.ok) {
          const data = await response.json();
          const product = data.product;

          if (product && product.images && product.images.length > imageIndex) {
            const imageUrl = product.images[imageIndex].src.replace(/\.([^.]+)$/, '_100x100.$1');
            const imgEl = document.querySelector(`.marker-product-img[data-handle="${handle}"]`);
            if (imgEl) {
              imgEl.src = imageUrl;
            }
          }
        }
      } catch (error) {
        // Silent fail - image won't load but progress bar still works
      }
    }
  }

  function isBodysuit(item) {
    if (productCollectionCache.hasOwnProperty(item.id)) {
      return productCollectionCache[item.id];
    }

    const tags = (item.tags || []).map(t => t.toLowerCase());
    if (tags.some(tag => tag.includes('bodysuit-collection'))) {
      productCollectionCache[item.id] = true;
      return true;
    }

    const type = (item.product_type || '').toLowerCase();
    if (type.includes('bodysuit')) {
      productCollectionCache[item.id] = true;
      return true;
    }

    const handle = (item.handle || '').toLowerCase();
    if (handle.includes('bodysuit')) {
      productCollectionCache[item.id] = true;
      return true;
    }

    const title = (item.title || '').toLowerCase();
    if (title.includes('bodysuit')) {
      productCollectionCache[item.id] = true;
      return true;
    }

    productCollectionCache[item.id] = false;
    return false;
  }

  function updateProductCollections(items) {
    items.forEach(item => isBodysuit(item));
  }

  function showTier2Notification() {
    const notification = document.getElementById('tier2-notification');
    const tier2Milestone = document.querySelector('[data-tier="2"]');

    if (!tier2Milestone || !notification) return;

    const rect = tier2Milestone.getBoundingClientRect();
    const top = rect.bottom + 15;
    const left = rect.left + (rect.width / 2) - 120;

    notification.style.position = 'fixed';
    notification.style.top = Math.max(10, top) + 'px';
    notification.style.left = Math.max(10, Math.min(left, window.innerWidth - 250)) + 'px';
    notification.style.display = 'block';
    notification.classList.add('active');
    notification.dataset.order = '1';

    repositionNotifications();
  }

  function closeTier2Notification() {
    const notification = document.getElementById('tier2-notification');
    if (notification) {
      notification.style.display = 'none';
      notification.classList.remove('active');
      repositionNotifications();
    }
  }

  function showTier3Notification() {
    const notification = document.getElementById('tier3-notification');
    const tier3Milestone = document.querySelector('[data-tier="3"]');

    if (!tier3Milestone || !notification) return;

    const rect = tier3Milestone.getBoundingClientRect();
    const top = rect.bottom + 15;
    const left = rect.left + (rect.width / 2) - 120;

    notification.style.position = 'fixed';
    notification.style.top = Math.max(10, top) + 'px';
    notification.style.left = Math.max(10, Math.min(left, window.innerWidth - 250)) + 'px';
    notification.style.display = 'block';
    notification.classList.add('active');
    notification.dataset.order = '2';

    repositionNotifications();
  }

  function closeTier3Notification() {
    const notification = document.getElementById('tier3-notification');
    if (notification) {
      notification.style.display = 'none';
      notification.classList.remove('active');
      repositionNotifications();
    }
  }

  function repositionNotifications() {
    const tier2Notification = document.getElementById('tier2-notification');
    const tier3Notification = document.getElementById('tier3-notification');
    const progressBar = document.getElementById('cart-goal-progress');

    if (!progressBar) return;

    const progressRect = progressBar.getBoundingClientRect();
    const baseTop = progressRect.bottom + 10;
    const centerLeft = progressRect.left + (progressRect.width / 2);

    const activeNotifications = [];
    if (tier2Notification && tier2Notification.classList.contains('active')) {
      activeNotifications.push(tier2Notification);
    }
    if (tier3Notification && tier3Notification.classList.contains('active')) {
      activeNotifications.push(tier3Notification);
    }

    if (activeNotifications.length === 0) return;

    if (activeNotifications.length === 1) {
      const notification = activeNotifications[0];
      notification.style.top = baseTop + 'px';
      notification.style.left = Math.max(10, centerLeft - 120) + 'px';
    } else {
      activeNotifications.forEach((notification, index) => {
        const offset = index * 70;
        notification.style.top = (baseTop + offset) + 'px';
        notification.style.left = Math.max(10, Math.min(centerLeft - 120, window.innerWidth - 250)) + 'px';
      });
    }
  }

  function openStraplessBraDrawer() {
    const drawer = document.querySelector('quick-buy-drawer[handle="free-strapless-push-up-bra"]');
    if (!drawer) return;

    if (drawer.show) {
      drawer.show();
    } else if (drawer.open) {
      drawer.open();
    } else if (drawer.toggleAttribute) {
      drawer.toggleAttribute('open');
    } else {
      drawer.setAttribute('open', '');
      drawer.dispatchEvent(new Event('show'));
    }
  }

  function openLaundryBagDrawer() {
    const drawer = document.querySelector('quick-buy-drawer[handle="free-delicate-laundry-bag"]');
    if (!drawer) return;

    if (drawer.show) {
      drawer.show();
    } else if (drawer.open) {
      drawer.open();
    } else if (drawer.toggleAttribute) {
      drawer.toggleAttribute('open');
    } else {
      drawer.setAttribute('open', '');
      drawer.dispatchEvent(new Event('show'));
    }
  }

  async function getExchangeRateToUSD() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      const activeCurrency = window.Shopify.currency.active;
      const rate = window.Shopify.currency.rate || 1;

      if (activeCurrency === 'USD') {
        return 1;
      }

      return rate;
    }

    return 1;
  }

  function convertToUSD(amountInLocalCurrency, exchangeRate) {
    if (exchangeRate && exchangeRate !== 1) {
      return amountInLocalCurrency / exchangeRate;
    }
    return amountInLocalCurrency;
  }

  function updateCartProgress() {
    fetch('/cart.json')
      .then(response => response.json())
      .then(async (cart) => {
        updateProductCollections(cart.items);

        let bodysuitCount = 0;
        straplessBraInCart = false;
        laundryBagInCart = false;

        const cartTotalLocal = cart.total_price / 100;
        const exchangeRate = await getExchangeRateToUSD();
        const cartTotal = convertToUSD(cartTotalLocal, exchangeRate);

        cart.items.forEach(item => {
          if (item.handle === STRAPLESS_BRA_HANDLE) {
            straplessBraInCart = true;
          }

          if (item.handle === LAUNDRY_BAG_HANDLE) {
            laundryBagInCart = true;
          }

          if (isBodysuit(item)) {
            bodysuitCount += item.quantity;
          }
        });

        const tier1 = true;
        const tier2 = cartTotal >= 90 && straplessBraInCart;
        const tier3 = cartTotal >= 120 && laundryBagInCart;
        const tier4 = bodysuitCount >= 5;

        const tier2Available = cartTotal >= 90;
        const tier3Available = cartTotal >= 120;

        const shouldShowTier2Notification = (cartTotal >= 90) && !straplessBraInCart;
        const shouldShowTier3Notification = (cartTotal >= 120) && !laundryBagInCart;

        let progress = 25;
        if (tier2) progress = 50;
        if (tier3) progress = 75;
        if (tier4) progress = 100;

        let currentTier = 1;
        if (tier4) currentTier = 4;
        else if (tier3) currentTier = 3;
        else if (tier2) currentTier = 2;

        const newState = JSON.stringify({ bodysuitCount, cartTotal, tier1, tier2, tier3, tier4, progress, currentTier, straplessBraInCart, laundryBagInCart });

        if (newState === lastState) return;
        lastState = newState;

        if (shouldShowTier2Notification && !tier2PreviouslyUnlocked) {
          tier2PreviouslyUnlocked = true;
          showTier2Notification();
        } else if (!shouldShowTier2Notification) {
          tier2PreviouslyUnlocked = false;
          closeTier2Notification();
        }

        if (shouldShowTier3Notification && !tier3PreviouslyUnlocked) {
          tier3PreviouslyUnlocked = true;
          showTier3Notification();
        } else if (!shouldShowTier3Notification) {
          tier3PreviouslyUnlocked = false;
          closeTier3Notification();
        }

        let nextMilestoneText = '';
        if (cartTotal < 90) {
          const neededUSD = 90 - cartTotal;
          const neededLocal = Math.ceil(neededUSD * exchangeRate);
          const currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
          let formattedAmount;
          try {
            formattedAmount = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(neededLocal);
          } catch (e) {
            formattedAmount = '$' + neededLocal;
          }
          nextMilestoneText = `Spend ${formattedAmount} more to unlock free gifts!`;
        } else if (!straplessBraInCart) {
          nextMilestoneText = `Add the Free Strapless Bra to your cart!`;
        } else if (cartTotal < 120) {
          const neededUSD = 120 - cartTotal;
          const neededLocal = Math.ceil(neededUSD * exchangeRate);
          const currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
          let formattedAmount;
          try {
            formattedAmount = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(neededLocal);
          } catch (e) {
            formattedAmount = '$' + neededLocal;
          }
          nextMilestoneText = `Spend ${formattedAmount} more to unlock a Free Laundry Bag!`;
        } else if (!laundryBagInCart) {
          nextMilestoneText = `Add the Free Laundry Bag to your cart!`;
        } else if (!tier4) {
          const needed = 5 - bodysuitCount;
          if (needed === 1) {
            nextMilestoneText = `Add 1 more bodysuit: Pay for 2, Get 3 Free!`;
          } else {
            nextMilestoneText = `Add ${needed} more bodysuits: Pay for 2, Get 3 Free!`;
          }
        } else {
          nextMilestoneText = '🎉 All rewards unlocked! Buy 2, Get 3 Free!';
        }

        updateProgressDOM(progress, currentTier, nextMilestoneText, { tier2, tier3, tier4, tier2Available, tier3Available, bodysuitCount });
      })
      .catch(() => {
        // Silent fail - cart fetch failed but we'll retry on next poll
      });
  }

  function updateProgressDOM(progress, currentTier, headline, tiers) {
    const progressEl = document.getElementById('cart-goal-progress');
    if (!progressEl) return;

    const headlineEl = progressEl.querySelector('.cart-goal-compact-headline');
    if (headlineEl) {
      headlineEl.textContent = headline;
    }

    const progressFill = progressEl.querySelector('.cart-goal-compact-progress-fill');
    if (progressFill) {
      progressFill.style.width = progress + '%';
    }

    const milestoneEls = progressEl.querySelectorAll('[data-tier]');
    milestoneEls.forEach((el, index) => {
      const tier = index + 2;
      const isUnlocked = (tier === 2 && tiers.tier2) ||
                        (tier === 3 && tiers.tier3) ||
                        (tier === 4 && tiers.tier4);

      const isAvailable = (tier === 2 && tiers.tier2Available) ||
                          (tier === 3 && tiers.tier3Available) ||
                          (tier === 4 && tiers.tier4);

      const marker = el.querySelector('[data-marker]');
      if (isUnlocked) {
        el.classList.add('active');
        marker.classList.add('unlocked');
      } else {
        el.classList.remove('active');
        marker.classList.remove('unlocked');
      }

      if (isAvailable) {
        el.classList.add('available');
      } else {
        el.classList.remove('available');
      }
    });
  }

  function setupEventListeners() {
    const openDrawerBtn = document.getElementById('tier2-open-drawer-btn');
    const closeNotificationBtn = document.getElementById('tier2-close-notification-btn');

    if (openDrawerBtn) {
      openDrawerBtn.addEventListener('click', function(e) {
        openStraplessBraDrawer();
        closeTier2Notification();
      });
    }

    if (closeNotificationBtn) {
      closeNotificationBtn.addEventListener('click', function(e) {
        closeTier2Notification();
      });
    }

    const openLaundryBagDrawerBtn = document.getElementById('tier3-open-drawer-btn');
    const closeLaundryBagNotificationBtn = document.getElementById('tier3-close-notification-btn');

    if (openLaundryBagDrawerBtn) {
      openLaundryBagDrawerBtn.addEventListener('click', function(e) {
        openLaundryBagDrawer();
        closeTier3Notification();
      });
    }

    if (closeLaundryBagNotificationBtn) {
      closeLaundryBagNotificationBtn.addEventListener('click', function(e) {
        closeTier3Notification();
      });
    }
  }

  function initCartProgress() {
    loadProductImages();
    updateCartProgress();

    document.addEventListener('cart:updated', updateCartProgress);
    document.addEventListener('cart-updated', updateCartProgress);
    document.addEventListener('shopify:section:load', updateCartProgress);

    // OPTIMIZATION: Reduced polling from 500ms to 2000ms
    setInterval(updateCartProgress, POLLING_INTERVAL);
  }

  // Single initialization point (fixed duplicate listeners)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupEventListeners();
      initCartProgress();
    });
  } else {
    setupEventListeners();
    initCartProgress();
  }

})();
